import { User } from '../../types';

export const mockUsers: User[] = [
  {
    id: '1',
    email: 'support@ntsports.tech',
    name: 'Super Admin',
    userType: 'personal',
    status: 'active',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=admin',
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: '2',
    email: 'org.admin@example.com',
    name: 'Organization Admin',
    userType: 'organization',
    status: 'active',
    organizationId: 'org-1',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=orgadmin',
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: '3',
    email: 'user1@example.com',
    name: 'John Doe',
    userType: 'organization',
    status: 'active',
    organizationId: 'org-2',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=john',
    createdAt: '2024-01-02T00:00:00Z',
    updatedAt: '2024-01-02T00:00:00Z'
  },
  {
    id: '4',
    email: 'user2@example.com',
    name: 'Jane Smith',
    userType: 'organization',
    status: 'active',
    organizationId: 'org-3',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=jane',
    createdAt: '2024-01-03T00:00:00Z',
    updatedAt: '2024-01-03T00:00:00Z'
  }
];

export const findUserByEmail = (email: string): User | undefined => {
  return mockUsers.find(user => user.email === email);
};

export const findUserById = (id: string): User | undefined => {
  return mockUsers.find(user => user.id === id);
};